import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8">
          {t('section.category')}
        </h2>

        <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-10 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}